(()=>{
  'use strict';
  function normalizePhone(value){
    const digits=String(value||'').replace(/\D/g,'');
    if(!/^(?:90)?0?5\d{9}$/.test(digits))throw Error('phone');
    return '+90'+digits.slice(-10);
  }
  function buildTransfer(values,districts,root='/'){
    const clean=key=>String(values[key]||'').trim();
    const province=clean('province'),district=clean('district');
    if(!Object.hasOwn(districts,province)||!districts[province].includes(district))throw Error('district');
    if(!clean('first_name')||!clean('last_name')||clean('address1').length<10)throw Error('address');
    if(clean('zip')&&!/^\d{5}$/.test(clean('zip')))throw Error('zip');
    const phone=normalizePhone(clean('phone'));
    const fields={first_name:clean('first_name'),last_name:clean('last_name'),address1:[clean('address1'),clean('apartment')].filter(Boolean).join(' / '),address2:district,city:province,province,country:'TR',phone};
    if(fields.address1.length>255)throw Error('address');
    if(clean('zip'))fields.zip=clean('zip');
    const params=new URLSearchParams();
    Object.entries(fields).forEach(([key,value])=>params.set('checkout[shipping_address]['+key+']',value));
    if(clean('email'))params.set('checkout[email]',clean('email'));
    params.set('checkout[phone]',phone);
    params.set('locale','tr');
    return {url:root+'checkout?'+params.toString(),attributes:{'İl':province,'İlçe':district,'Apartman / Daire':clean('apartment'),'Adres formu':'OtoWix ayrı ilçe v1'}};
  }
  if(typeof module==='object'&&module.exports)module.exports={normalizePhone,buildTransfer};
  if(typeof document==='undefined')return;
  const dialog=document.getElementById('OwAddressDialog');
  if(!dialog)return;
  const form=dialog.querySelector('form'),province=form.elements.province,district=form.elements.district;
  const errorBox=dialog.querySelector('[data-address-error]'),status=dialog.querySelector('[data-address-status]');
  const submit=dialog.querySelector('[data-address-submit]'),close=dialog.querySelector('[data-address-close]');
  const root=dialog.dataset.root||'/';
  let districts={},districtPromise=null,busy=false,opening=false,leaving=false,wasDrawer=false,opener=null;
  const text=key=>dialog.dataset[key]||'';
  const money=(amount,currency)=>new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency}).format(amount/100);
  function fillDistricts(){
    district.replaceChildren(new Option(province.value?text('chooseDistrict'):text('firstProvince'),''));
    const list=districts[province.value]||[];
    district.disabled=!list.length;
    list.forEach(name=>district.add(new Option(name,name)));
  }
  province.addEventListener('change',fillDistricts);
  async function loadDistricts(){
    if(!districtPromise)districtPromise=fetch(dialog.dataset.districtsUrl).then(async response=>{
      if(!response.ok)throw Error('load');
      districts=await response.json();
      province.replaceChildren(new Option(text('chooseProvince'),''));
      Object.keys(districts).sort((a,b)=>a.localeCompare(b,'tr')).forEach(name=>province.add(new Option(name,name)));
      province.disabled=false;
      fillDistricts();
    }).catch(error=>{districtPromise=null;throw error;});
    return districtPromise;
  }
  async function openAddress(trigger){
    if(opening||dialog.open)return;
    opening=true;leaving=false;opener=trigger;errorBox.hidden=true;
    const drawer=document.getElementById('CartDrawer');
    wasDrawer=Boolean(drawer?.open);
    if(wasDrawer)drawer.close();
    dialog.showModal();document.body.classList.add('ow-address-open');
    status.textContent=text('loading');submit.disabled=true;
    try{
      const response=await fetch(root+'cart.js');
      if(!response.ok)throw Error('load');
      const cart=await response.json();
      if(!cart.item_count)throw Error('empty');
      dialog.querySelector('[data-address-total]').textContent=money(cart.total_price,cart.currency);
      dialog.querySelector('[data-address-count]').textContent=String(cart.item_count);
      await loadDistricts();
      status.textContent='';submit.disabled=false;form.elements.first_name.focus();
    }catch(error){errorBox.textContent=error.message==='empty'?text('errorEmpty'):text('errorLoad');errorBox.hidden=false;status.textContent='';}
    finally{opening=false;}
  }
  close.addEventListener('click',()=>{if(!busy)dialog.close();});
  dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  dialog.addEventListener('close',()=>{
    document.body.classList.remove('ow-address-open');
    if(!leaving&&wasDrawer)document.getElementById('CartDrawer')?.showModal();
    if(!leaving)opener?.focus();
  });
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('[data-cart-checkout],button[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],a[data-address-open]');
    if(!trigger||trigger.disabled||trigger.hasAttribute('data-shopier-checkout')||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();event.stopImmediatePropagation();openAddress(trigger);
  },true);
  document.addEventListener('submit',event=>{
    if(event.target===form||event.submitter?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();openAddress(event.submitter);
  },true);
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(busy||!form.reportValidity())return;
    errorBox.hidden=true;
    try{
      const transfer=buildTransfer(Object.fromEntries(new FormData(form)),districts,root);
      busy=true;submit.disabled=true;close.disabled=true;submit.textContent=text('saving');
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:transfer.attributes})});
      if(!response.ok)throw Error('load');
      const cart=await response.json();
      if(!cart.item_count)throw Error('empty');
      leaving=true;window.location.assign(transfer.url);
    }catch(error){
      const messages={phone:'errorPhone',district:'errorDistrict',address:'errorAddress',zip:'errorZip',empty:'errorEmpty'};
      errorBox.textContent=text(messages[error.message]||'errorLoad');errorBox.hidden=false;
      busy=false;submit.disabled=false;close.disabled=false;submit.textContent=text('continue');
    }
  });
})();
